(function waitMap() {
    const map = window.GLOBAL_arMapObjects?.MAP_v33;

    if (!map) {
        setTimeout(waitMap, 100);
        return;
    }

    document.querySelector('.map-zoom-in')?.addEventListener('click', () => {
        map.setZoom(map.getZoom() + 1);
    });

    document.querySelector('.map-zoom-out')?.addEventListener('click', () => {
        map.setZoom(map.getZoom() - 1);
    });

    document.querySelector('.map-type')?.addEventListener('change', (event) => {
        map.setType(event.target.value);
    });
})();
